import { Badge } from "react-bootstrap";

const styles = {
  badge: {
    backgroundColor: "transparent",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#d0d0d0",
    fontWeight: "normal",
    borderRadius: "0.3rem",
    padding: "0.35em 0.6em",
    display: "inline-block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flexShrink: 1,
  },
  sinMotivo: {
    backgroundColor: "#f8d7da",
    borderColor: "#f5c2c7",
    color: "#842029",
    fontWeight: "bold",
  },
};

function Motivo({ motivo }) {
  const esSinMotivo = motivo === "Sin motivo asignado";
  const estilo = esSinMotivo
    ? { ...styles.badge, ...styles.sinMotivo }
    : styles.badge;

  return (
    <Badge bg="light" className="text-dark" style={estilo} title={motivo}>
      {motivo}
    </Badge>
  );
}

export default Motivo;